<template>
    <div class="app-container">
        <div class="app-content" id="app-content">
            <HeaderView />
            <router-view />
            <FooterView />
            <FloatingContact />
        </div>
    </div>
</template>

<script>
import HeaderView from './components/HeaderView.vue'
// import FooterView from './components/FooterView.vue'
import FooterView from './components/FooterView2.vue'
import FloatingContact from './components/FloatingContact.vue'

export default {
  name: 'App',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    HeaderView,
    // eslint-disable-next-line vue/no-unused-components
    FooterView,
    FloatingContact
  }
}
</script>


<style>
.app-container {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
}

.app-content {
    width: 100%;
    max-width: 100%;
    transform-origin: center top;
}
</style>